interface TimeParams {
  start?: number;
  end?: number;
}

const hashSearchParams = (hash: string): URLSearchParams => {
  if (!hash) {
    return new URLSearchParams();
  }

  return new URLSearchParams(hash.replace(/^#/, ''));
};

const getParam = (search: URLSearchParams, hash: URLSearchParams, key: string): string | null => search.get(key) ?? hash.get(key);

export const parseTimeParams = (url: string): TimeParams => {
  try {
    // Use base URL for relative URLs, the fallback is just an example so we can build the URL object even if the URL is relative
    const urlObj = new URL(url, 'https://example.com');
    const search = urlObj.searchParams;
    const hash = hashSearchParams(urlObj.hash);

    // Check for 't' parameter (format: t=start,end or t=start) in ? or #
    const tParam = getParam(search, hash, 't');
    if (tParam) {
      const timeParts = tParam.split(',').map((t) => parseFloat(t));

      return {
        start: !isNaN(timeParts[0]) ? timeParts[0] : undefined,
        end: !isNaN(timeParts[1]) ? timeParts[1] : undefined,
      };
    }

    // Check for separate start/end parameters in ? or #
    const startParam = getParam(search, hash, 'start');
    const endParam = getParam(search, hash, 'end');
    const startVal = startParam ? parseFloat(startParam) : NaN;
    const endVal = endParam ? parseFloat(endParam) : NaN;

    return {
      start: !isNaN(startVal) ? startVal : undefined,
      end: !isNaN(endVal) ? endVal : undefined,
    };
  } catch {
    // If URL parsing fails, return empty params
    return {};
  }
};
